
import { defineComponent, ref, onMounted } from "vue";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import testMail from "@/components/modals/forms/testMail.vue";
import { reinitializeComponents } from "@/core/plugins/keenthemes";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import axios from "@/axios-instance";
import moment from "moment";
import Permission from "@/core/config/Permission";
import { debounce } from "debounce";
import { hideModal } from "@/core/helpers/dom";
import Dropzone from "dropzone";
import * as XLSX from "xlsx-js-style"; //đọc thử file .csv vừa chọn để tóm tắt + xem trước người nhận
import { exportStyledFromHeaderMap } from "@/core/helpers/exportXlsx"; //xuất danh sách gửi lỗi

import ModalViewTemplateMail from "@/components/modals/wizards/ModalViewTemplateMail.vue";

interface ICustomer {
  id: string;
  emailTotal: string;
  failedEmailTotal: string;
  condDirectRecruitment: string;
  checkbox: boolean;
  status: string;
  sentEmailTotal: string;
  failedItems: string[];
  percent: string;
  failedZaloTotal?: string;
  sentSmsTotal?: string;
  sentZaloTotal?: string;
  failedSmsTotal?: number;
  failedZaloItems?: string[];
  failedSmsItems?: string[];

}
interface IPagination {
  currentPage: number;
  total: number;
  limit: number;
}
interface IData {
  name: string;
  phase: string;
  method: string;
  graduationStatus: string;
  typeTemplate: string;
  typeTime: string;
  time: string;
  id: string;
  peopleTarget: string;
  smsMessage: string;
  zaloTemplateId: string;

}
export default defineComponent({
  name: "customers-listing",
  components: {
    Datatable,
    testMail,
    ModalViewTemplateMail,
  },
  data() {
    return {
      checkDefault: false,
      arrPhase: [] as any,
      //link file mẫu theo môi trường (trước hardcode api.dev...) — file tĩnh ở ROOT host API
      sampleImportUrl: (process.env.VUE_APP_API_URL || '').replace(/\/api\/?$/, '') + '/sample_marketingcampaign_abc.csv',
      loading: true,
      arrAdmissionMethod: [] as any,
      mailtemplate: [] as any,
      tempPhase: "",
      editorData: "",
      titleMail: "",
      dropzoneInstance: null as any, //giữ instance để nút Lưu gọi processQueue
      importPreview: null as any,    //tóm tắt file vừa chọn: {fileName,total,noEmail,noPhone,rows,error}
      importPreviewVisible: false,   //popup xem trước danh sách người nhận
      failedVisible: false,          //popup danh sách gửi lỗi
      failedModal: { campaignName: "", channel: "email", channelLabel: "Email", items: [] as any[] },
    };
  },
  watch: {
    search: debounce(async function (this) {
      this.searchItems();
    }, 300),
  },
  methods: {
    viewMail() {
      let data = this.mailtemplate.find((i: any) => i.id == this.formData.typeTemplate)
      console.log('data',data)
      this.editorData = data.body?.substr(0,data.body?.length - 75)
      this.titleMail = data.title
      this.viewTemplateMail?.showModal()
    },
    peopleTargetChange() {
      if(this.formData.peopleTarget == 'all_noreg') {
        this.formData.phase = '0'
        this.formData.method = 'all'
      }
    },
    getCookie(name: string): string|null {
      const nameLenPlus = (name.length + 1);
      return document.cookie
        .split(';')
        .map(c => c.trim())
        .filter(cookie => {
          return cookie.substring(0, nameLenPlus) === `${name}=`;
        })
        .map(cookie => {
          return decodeURIComponent(cookie.substring(nameLenPlus));
        })[0] || null;
    },
    initDropzone() {
        let this_ = this
        if (Dropzone.instances.length > 0) {
            Dropzone.instances.forEach((e: any) => {
                e.off();
                e.destroy();
            });
        }
        let myDropzone = new Dropzone("#id_dropzone", {
            url:`${process.env.VUE_APP_API_URL}/campaign/marketing/import/csv`,
            headers:{"Authorization":'Bearer ' + this.getCookie("accessToken")},
            dictDefaultMessage: "Nhấn để chọn file .csv, hoặc kéo thả vào đây",
            dictInvalidFileType: "Bạn không thể tải tệp không đúng định dạng",
            dictFileTooBig: "Kích thước tệp quá lớn. Tối đa 25MB",
            dictMaxFilesExceeded: "Bạn chỉ được upload tối đa 1 files",
            maxFilesize: 25,
            maxFiles: 1,
            addRemoveLinks: true,
            autoProcessQueue: false,
            //CHỈ .csv: backend đọc bằng fast-csv, thả .xlsx vào là parse ra rác/lỗi
            //(trước đây acceptedFiles cho cả xlsx/xls nên người dùng bị dẫn vào đường cụt).
            acceptedFiles: `.csv, text/csv, text/comma-separated-values, application/csv`,
            init: function () {
                myDropzone = this;
                //Giữ instance để nút Lưu gọi thẳng (xem startUpload). TRƯỚC ĐÂY bắt sự kiện bằng
                //document.getElementById("uploadFiles") ngay lúc init — mà lúc đó form đang ở chế độ
                //"Thí sinh trên hệ thống" nên nút #uploadFiles CHƯA TỒN TẠI (v-else) -> listener không
                //bao giờ gắn được -> chuyển sang Import, chọn file, bấm Lưu thì KHÔNG có gì xảy ra.
                this_.dropzoneInstance = this;
                myDropzone.removeAllFiles()
                document.querySelectorAll(".dz-preview").forEach(e => e.remove());
                //Chọn file xong: đọc thử ngay tại trình duyệt để BIẾT SẼ GỬI CHO BAO NHIÊU NGƯỜI
                //trước khi bấm Lưu (trước đây thả file vào là hết, phải lưu rồi mở chi tiết mới biết).
                this.on("addedfile", function (file) {
                    this_.readImportPreview(file);
                });
                this.on("removedfile",async function (file) {
                    this_.importPreview = null;
                });
                this.on("sending",async function (file, xhr, formData) {
                  // console.log('file',file)
                  // console.log('formData',formData)
                  // formData.append('info', info);
                    // if(file && file.fileName) {
                    //     await axios.delete(`/admission/file/${file.fileName}`)
                    // }
                });
                this.on("success",async function (file, response) {
                  // console.log('response',response)
                  let data = response
                  data.campaign.createdAtFormat = moment(data.campaign.createdAt).format("DD/MM/YYYY HH:mm");
                  data.campaign.createdAt = data.campaign.createdAt?Number(new Date(data.campaign.createdAt)):'',
                data.campaign.failedEmailTotal =
                  data.campaign.status != "none"
                    ? data.campaign.emailTotal - data.campaign.sentEmailTotal
                    : 0;
                data.campaign.percent = 0; //(data.item.sentEmailTotal*100/data.item.emailTotal).toFixed(0)
                data.campaign.groupTarget = null;
                this_.tableData.unshift(data.campaign);
                hideModal(this_.addExporResultModalRef);
                reinitializeComponents();
                Swal.close()
                  //admission/export/excel/unsynchronize

                });
                this.on("error",function (file, response) {
                    console.log('response',response)
                    Swal.fire({
                        //response có thể là chuỗi (lỗi của dropzone: sai định dạng/quá nặng) hoặc body
                        //JSON của backend (errorMessage) — đọc thiếu nhánh là popup trống trơn
                        text: this_.dropzoneErrorText(response),
                        icon: "error",
                        buttonsStyling: false,
                        confirmButtonText: "Trở lại",
                        customClass: {
                            confirmButton: "btn btn-primary",
                        },
                    }).then(() => {
                        Swal.close()
                    });

                })
            }
        });
    },
    //Bỏ file đang chọn (thẻ preview của Dropzone đã ẩn nên cần lối gỡ file ở dòng tóm tắt)
    clearImportFile() {
      try { (this.dropzoneInstance as any)?.removeAllFiles(true) } catch (e) { /* bỏ qua */ }
      this.importPreview = null
    },
    //Mở danh sách gửi lỗi của 1 chiến dịch theo kênh (email/sms/zalo)
    openFailedItems(customer: any, channel: string) {
      const map: any = {
        email: { label: "Email", items: customer.failedItems },
        sms: { label: "SMS", items: customer.failedSmsItems },
        zalo: { label: "Zalo", items: customer.failedZaloItems },
      }
      const picked = map[channel] || map.email
      this.failedModal = {
        campaignName: customer.name || "",
        channel,
        channelLabel: picked.label,
        items: Array.isArray(picked.items) ? picked.items : [],
      }
      this.failedVisible = true
    },
    //Tải danh sách lỗi ra Excel để gửi cho người phụ trách sửa dữ liệu
    exportFailedItems() {
      const isEmail = this.failedModal.channel === "email"
      exportStyledFromHeaderMap({
        title: `DANH SÁCH GỬI LỖI — ${this.failedModal.channelLabel.toUpperCase()}`,
        fileBaseName: "danh-sach-gui-loi",
        sheetName: "Gửi lỗi",
        summary: `Chiến dịch: ${this.failedModal.campaignName || "—"} · ${this.failedModal.items.length} trường hợp`,
        header: {
          fullName: "Họ và tên",
          contact: isEmail ? "Email" : "Số điện thoại",
          error: "Lý do không gửi được",
        },
        items: this.failedModal.items.map((r: any) => ({
          fullName: r.fullName || "",
          contact: (isEmail ? r.email : r.phone) || "",
          error: r.error || "",
        })),
        widths: { fullName: 24, contact: 30, error: 70 },
      })
    },
    //Gom mọi kiểu lỗi upload về một câu đọc được cho người dùng
    dropzoneErrorText(response: any) {
      if (!response) { return "Không tải được file lên. Vui lòng thử lại." }
      if (typeof response === "string") { return response }
      const msg = response.errorMessage || response.message || ""
      //BE ném mã kỹ thuật kiểu "APP-100-300|Something went wrong with CSV Template..."
      if (String(msg).includes("APP-100-300")) { return "File không đúng mẫu — tải file mẫu và điền theo đúng các cột." }
      if (String(msg).includes("APP-100-400")) { return "File không có dòng dữ liệu nào để tạo chiến dịch." }
      if (String(msg).includes("APP-100-500")) { return "Chưa chọn được file. Vui lòng chọn lại." }
      return String(msg).split("|").pop() || "Không tải được file lên. Vui lòng thử lại."
    },
    //Đọc file .csv vừa chọn NGAY TẠI TRÌNH DUYỆT (không đụng server) để tóm tắt: bao nhiêu người
    //nhận, bao nhiêu dòng thiếu email/SĐT — và cho xem trước danh sách trước khi lưu.
    readImportPreview(file: any) {
      this.importPreview = { fileName: file?.name || "", loading: true, rows: [], total: 0, noEmail: 0, noPhone: 0, error: "" }
      const reader = new FileReader()
      reader.onload = (e: any) => {
        try {
          //Bỏ BOM đầu file: Excel lưu CSV kèm ﻿ -> tên cột đầu thành "﻿hovaten",
          //đọc r.hovaten ra undefined và cả cột Họ tên hiện "—".
          const text = String(e.target.result || "").replace(/^﻿/, "")
          const wb = XLSX.read(text, { type: "string", raw: false })
          const raw = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { defval: "" }) as any[]
          //chuẩn hoá tên cột (bỏ BOM/khoảng trắng, về chữ thường) để không phụ thuộc cách gõ header
          const rows = raw.map((r) => {
            const o: any = {}
            Object.keys(r).forEach((k) => { o[String(k).replace(/^﻿/, "").trim().toLowerCase()] = r[k] })
            return o
          })
          const clean = rows.filter((r) => Object.values(r).some((v) => String(v || "").trim() !== ""))
          this.importPreview = {
            fileName: file?.name || "",
            loading: false,
            rows: clean,
            total: clean.length,
            noEmail: clean.filter((r) => !String(r.email || "").trim()).length,
            noPhone: clean.filter((r) => !String(r.dienthoai || "").trim()).length,
            error: clean.length === 0 ? "File không có dòng dữ liệu nào." : "",
          }
        } catch (err: any) {
          this.importPreview = { fileName: file?.name || "", loading: false, rows: [], total: 0, noEmail: 0, noPhone: 0, error: "Không đọc được file — kiểm tra lại định dạng theo file mẫu." }
        }
      }
      reader.onerror = () => {
        this.importPreview = { fileName: file?.name || "", loading: false, rows: [], total: 0, noEmail: 0, noPhone: 0, error: "Không đọc được file." }
      }
      reader.readAsText(file, "UTF-8")
    },
    //Bấm Lưu ở chế độ "Import tập tin": kiểm các thứ bắt buộc rồi mới đẩy file lên
    //(nhánh này KHÔNG đi qua submit()/el-form nên phải tự soát, kẻo tạo chiến dịch thiếu tên/mẫu).
    startUpload() {
      const warn = (text: string) => Swal.fire({
        text, icon: "warning", buttonsStyling: false, confirmButtonText: "Đã hiểu",
        customClass: { confirmButton: "btn btn-primary" },
      })
      const dz = this.dropzoneInstance as any
      if (!dz || dz.getQueuedFiles().length === 0) {
        return warn("Chọn file danh sách người nhận (.csv) trước khi lưu.")
      }
      if (!this.formData.name || !String(this.formData.name).trim()) {
        return warn("Đặt tên chiến dịch trước khi lưu.")
      }
      if (!this.optionData.type || this.optionData.type.length === 0) {
        return warn("Chọn ít nhất một kênh gửi (Email, SMS hoặc Zalo) trước khi lưu.")
      }
      if (this.optionData.type.includes("email") && !this.formData.typeTemplate) {
        return warn("Chọn mẫu email cho chiến dịch trước khi lưu.")
      }
      if (this.optionData.type.includes("zalo") && !this.formData.zaloTemplateId) {
        return warn("Chọn mẫu Zalo cho chiến dịch trước khi lưu.")
      }
      if (this.optionData.type.includes("sms") && !this.formData.smsMessage) {
        return warn("Nhập nội dung SMS trước khi lưu.")
      }
      this.popupLoading()
      dz.processQueue()
    },
    async getReviewZalo() {
      await axios
      .get(`campaign/zalo/template/${this.formData.zaloTemplateId}`)
      .then(({ data }) => {
        this.reviewZalo = data
      })
      .catch(({ response }) => {
        console.log("err", response);
      });
    },
    checkLength: function(evt = undefined as any) {
        let max = 164 //evt.target.max
        let min = 0 //evt.target.min
        let leng = this.formData.smsMessage.length
        if(leng >=min && leng <= max) {
            return true
        }
        else {
            this.formData.smsMessage = this.formData.smsMessage.slice(0,max)
            evt?.preventDefault();
        }
    },
    removeAccents(event) {
        let str = event.value
        var AccentsMap = [
            'aàảãáạăằẳẵắặâầẩẫấậ',
            'AÀẢÃÁẠĂẰẲẴẮẶÂẦẨẪẤẬ',
            'dđ',
            'DĐ',
            'eèẻẽéẹêềểễếệ',
            'EÈẺẼÉẸÊỀỂỄẾỆ',
            'iìỉĩíị',
            'IÌỈĨÍỊ',
            'oòỏõóọôồổỗốộơờởỡớợ',
            'OÒỎÕÓỌÔỒỔỖỐỘƠỜỞỠỚỢ',
            'uùủũúụưừửữứự',
            'UÙỦŨÚỤƯỪỬỮỨỰ',
            'yỳỷỹýỵ',
            'YỲỶỸÝỴ',
        ]
        for (var i = 0; i < AccentsMap.length; i++) {
            var re = new RegExp('[' + AccentsMap[i].substr(1) + ']', 'g')
            var char = AccentsMap[i][0]
            str = str.replace(re, char)
        }
        this.formData.smsMessage =  str
    },
    insertSomething(val) {
        let value = `##${val}##`
        var textArea = document.getElementsByName('smsMessage')[0] as any;
        var startPos = textArea.selectionStart,
            // get cursor's position:
            endPos = textArea.selectionEnd,
            cursorPos = startPos,
            tmpStr = textArea.value;

        if (value === null) {
            return;
        }
        // insert:
        this.formData.smsMessage = tmpStr.substring(0, startPos) + value + tmpStr.substring(endPos, tmpStr.length);

        // move cursor:
        setTimeout(() => {
            cursorPos += value.length;
            textArea.selectionStart = textArea.selectionEnd = cursorPos;
        }, 10);
        this.checkLength()
    },
    deleteRow(record) {
      if (record.status != "none") {
        return;
      }
      Swal.fire({
        text: `Bạn có muốn xóa chiến dịch này không?`,
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Trở lại",
        customClass: {
          confirmButton: "btn btn-primary order-2",
          cancelButton: "btn btn-light order-1",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          await axios
            .delete(`/campaign/${record.id}`)
            .then(({ data }) => {
              let index = this.tableData.findIndex(
                (item) => item.id == record.id
              );
              this.tableData.splice(index, 1);
              this.deleteCustomer(record.id);
            })
            .catch(({ response }) => {
              console.log("err", response);
            });
        }
        Swal.close();
      });
    },
    addRow() {
      this.isEdit = false;
      this.formData.name = "";
      this.formData.id = "";
      this.formData.phase = '0'//this.tempPhase;
      this.formData.method = "all";
      this.formData.peopleTarget = "all";
      this.formData.typeTemplate = "";
      this.formData.typeTime = "";
      this.formData.time = "";
      //Tạo mới: tick sẵn Email (kênh dùng gần như mọi chiến dịch) — vẫn bỏ được nếu chỉ gửi SMS/Zalo
      this.optionData.type = ['email']
      this.optionData.option = '1'
      this.importPreview = null //xoá tóm tắt file của lần mở trước (removeAllFiles chạy trước khi gắn handler)
      this.kt_modal_option_add?.click();
      this.formRef?.resetFields()
      setTimeout(()=> {
        this.initDropzone()
      },100)
    },
    async editRow(record) {

      this.isEdit = true;
      await axios
        .get(`/campaign/${record.id}`)
        .then(({ data }) => {
          this.formData.name = data.name;
          this.formData.id = data.id;
          this.formData.phase = data.phaseTarget != null ?data.phaseTarget.toString():data.phaseTarget;
          this.formData.method = data.methodTarget;
          this.formData.peopleTarget = data.peopleTarget;
          this.formData.typeTemplate = data.mailTemplateId?data.mailTemplateId:this.formData.typeTemplate;
          this.formData.smsMessage = data.smsMessage?data.smsMessage:this.formData.smsMessage
          this.formData.typeTime = "";
          this.formData.time = "";
          this.optionData.type = []
          this.optionData.option = '1'
          if(data.peopleTarget == 'custom') {
            this.optionData.option = '2'
          }
        //   this.optionData.option = data.
        if(data.mailChecked) {
            this.optionData.type.push('email')
          }
          if(data.smsChecked) {
            this.optionData.type.push('sms')
          }
          if(data.zaloChecked) {
            this.optionData.type.push('zalo')
          }
          this.kt_modal_option_add?.click();
        })
        .catch(({ response }) => {
          console.log("err", response);
        });
    },
    checkAll(value) {
      this.checkDefault = value;
      this.checkedCustomers = [];
      if (!value) {
        return;
      }
      const el = document.querySelectorAll(".form-auto-check");
      el.forEach((e) => {
        let ele = e as HTMLInputElement;
        this.checkedCustomers.push(ele.value as never);
      });
    },
    async getData() {
      this.initCustomers = [];
      this.tableData = [];
      this.loading = false;
      await axios
        .get("/campaign?type=marketing")
        .then(({ data }) => {
          data.sort((a,b)=> Number(new Date(b.createdAt)) - Number(new Date(a.createdAt)))
          data.forEach((item, index) => {
            item.createdAtFormat = moment(item.createdAt).format("DD/MM/YYYY HH:mm");
            item.createdAt = item.createdAt?Number(new Date(item.createdAt)):'',
            item.failedEmailTotal =
              item.status != "none" && item.failedItems? item.failedItems.length : 0;
            item.failedSmsTotal =
              item.status != "none" && item.failedSmsItems? item.failedSmsItems.length : 0;
            item.failedZaloTotal =
              item.status != "none" && item.failedZaloItems? item.failedZaloItems.length : 0;
            item.groupTarget = `${
              item.methodTarget == "HOCBA"
                ? "Học bạ"
                : item.methodTarget == "UMT"
                ? "UMT"
                : item.methodTarget == "DGNL"
                ? "Đánh giá năng lực ĐHQG"
                : item.methodTarget == "THPT"
                ? "Tốt nghiệp THPT"
                : item.methodTarget
                ? item.methodTarget
                : ''
            }`;
            item.percent = item.status != "none" ? "100" : "0";
          });
          this.tableData = data;
          this.loading = false;
          this.initCustomers.splice(
            0,
            this.tableData.length,
            ...this.tableData
          );
        })
        .catch(({ response }) => {
          console.log("err", response);
        });
        console.log('tableData',this.tableData)
    },
    async sendMail(record) {
      // this.tempRecord = record
      // this.kt_modal_option_send?.click()
      // return
      let text = "Bạn có muốn chạy chiến dịch này không?";
      if (record.status != "none") {
        text = "Bạn có muốn gửi lại cho những thí sinh đã gửi thất bại không?";
      }
      Swal.fire({
        text: text,
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Trở lại",
        customClass: {
          confirmButton: "btn btn-primary order-2",
          cancelButton: "btn btn-light order-1",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          document.getElementById(record.id)?.classList.toggle("active");
          await axios
            .post(`/campaign/marketing/run/${record.id}`)
            .then(({ data }) => {
              let failed = "";
              document.getElementById(record.id)?.classList.toggle("active");
              let index = this.tableData.findIndex(
                (item) => item.id == record.id
              );
              if(data.sendmailResult) {
                if ( data.sendmailResult.failedItems.length != 0) {
                  failed = `Đã có ${data.sendmailResult.failedItems.length} ứng viên không nhận được mail`;
                }
                this.tableData[index].sentEmailTotal = this.tableData[index].sentEmailTotal + data.sendmailResult.sentItems.length;
                this.tableData[index].failedEmailTotal = data.sendmailResult.failedItems.length;
                this.tableData[index].failedItems = data.sendmailResult.failedItems;
              }
              if(data.sendzaloResult) {
                if ( data.sendzaloResult.failedItems.length != 0) {
                  failed = `Đã có ${data.sendzaloResult.failedItems} ứng viên không nhận được tin nhắn zalo`;
                }
                this.tableData[index].sentZaloTotal = this.tableData[index].sentZaloTotal + data.sendzaloResult.sentItems.length;
                this.tableData[index].failedZaloTotal = data.sendzaloResult.failedItems.length;
                this.tableData[index].failedZaloItems = data.sendzaloResult.failedItems;
              }
              if(data.sendsmsResult) {
                if ( data.sendsmsResult.failedItems.length != 0) {
                  failed = `Đã có ${data.sendsmsResult.failedItems} ứng viên không nhận được tin nhắn zalo`;
                }
                this.tableData[index].sentSmsTotal = this.tableData[index].sentSmsTotal + data.sendsmsResult.sentItems.length;
                this.tableData[index].failedSmsTotal = data.sendsmsResult.failedItems.length;
                this.tableData[index].failedSmsItems = data.sendsmsResult.failedItems;
              }


              this.tableData[index].status = "sent";
              this.tableData[index].percent = "100"; //(+this.tableData[index].sentEmailTotal*100/+this.tableData[index].emailTotal).toFixed(0)
              reinitializeComponents();
              //Trước đây biến `failed` được tính rồi BỎ KHÔNG: chiến dịch gửi hỏng vài trăm địa chỉ
              //vẫn đóng popup như không có gì. Nay báo rõ kết quả chạy.
              if (failed) {
                Swal.fire({
                  html: `${failed}.<br/>Bấm vào dòng chiến dịch để xem danh sách lỗi, sửa email rồi chạy lại (chỉ gửi cho các trường hợp thất bại).`,
                  icon: "warning",
                  buttonsStyling: false,
                  confirmButtonText: "Đã hiểu",
                  customClass: { confirmButton: "btn btn-primary" },
                });
              } else {
                Swal.fire({
                  text: "Đã chạy chiến dịch xong.",
                  icon: "success",
                  buttonsStyling: false,
                  confirmButtonText: "Đóng",
                  customClass: { confirmButton: "btn btn-primary" },
                });
              }
            })
            .catch(({ response }) => {
              //bỏ cờ đang chạy (nhánh lỗi trước đây không tắt -> thanh tiến trình kẹt mãi)
              document.getElementById(record.id)?.classList.remove("active");
              //và nói cho người dùng biết lỗi gì — trước chỉ console.log rồi im lặng
              Swal.fire({
                text: response?.data?.errorMessage || response?.data?.message || "Không chạy được chiến dịch. Vui lòng thử lại.",
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Đóng",
                customClass: { confirmButton: "btn btn-primary" },
              });
              console.log("err", response);
            });
        }
      });
    },
  },
  async created() {
    this.getData();
    await axios
      .get("/phase")
      .then(({ data }) => {
        this.arrPhase = data.map((i) => {
          return { name: "Đợt " + i.phaseNo, id: i.phaseNo.toString() };
        });
        let temp = {
          name: "Tất cả",
          id: "0"
        }
        this.arrPhase.unshift(temp)
      })
      .catch(({ response }) => {
        console.log("err", response);
      });
    await axios
      .get("/phase/item/current")
      .then(({ data }) => {
        this.formData.phase = data.phaseNo.toString();
        this.tempPhase = this.formData.phase;
      })
      .catch(({ response }) => {
        console.log("err", response);
      });
    await axios
      .get("/mailtemplate")
      .then(({ data }) => {
        data.forEach((item, index) => {
          item.createdAt = moment(item.createdAt).format("DD/MM/YYYY");
          item.index = index + 1;
        });
        this.mailtemplate = data;
      })
      .catch(({ response }) => {
        console.log("err", response);
      });
    await axios
      .get("/campaign/zalo/templateids")
      .then(({ data }) => {
         //data = data.data
        this.arrZaloTemplateids = data.map(i=>{return {
          value: i.templateId,
          label: i.templateName
        }});
        if(this.arrZaloTemplateids.length != 0) {
          this.formData.zaloTemplateId = this.arrZaloTemplateids[0].value
          this.getReviewZalo()
        }
      })
      .catch(({ response }) => {
        console.log("err", response);
      });

      await axios
      .get("/campaign/sms/messages")
      .then(({ data }) => {
        this.formData.smsMessage = data.thongbaotrungtuyen
      })
      .catch(({ response }) => {
        console.log("err", response);
      });
  },
  setup() {
    Dropzone.autoDiscover = false;
    const filterList = ref<any>();
    const reviewZalo = ref<any>(null);
    const viewTemplateMail = ref<any>();
    const arrZaloTemplateids = ref<any>([]);

    const arrMajors = ref([
      {
        value: 0,
        name: "Tất cả",
        id: 0,
        code: "0",
      },
    ]);
    const optionRules = ref({
      typeTemplate: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "change",
        },
      ],
    })
    const rules = ref({
      typeTemplate: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "change",
        },
      ],
      name: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "change",
        },
      ],
      smsMessage: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "change",
        },
      ],

    });
    const pagination = ref<IPagination>({
      currentPage: 1,
      total: 0,
      limit: 25,
    });
    const checkedCustomers = ref([]);
    //(bỏ failedItemstableHeader: bảng lỗi lồng trong dropdown đã thay bằng modal danh sách gửi lỗi)
    const tableHeader = ref([
      //     {
      //     key: "checkbox",
      //     sortable: false,
      //     class:"d-flex",
      //     method: "checkall",
      //   },
      {
        name: "Ngày",
        key: "createdAt",
        sortable: true,
        class: "",
      },
      {
        name: "Đợt",
        key: "phaseTarget",
        sortable: true,
        class: "text-center w-100px",
      },
      {
        name: "Tên chiến dịch",
        key: "name",
        sortable: true,
      },
      {
        name: "Nhóm gửi",
        key: "groupTarget",
        sortable: false,
        class: "",
      },
      {
        //Trước đây phải mở modal sửa mới biết chiến dịch gửi qua kênh nào
        name: "Kênh",
        key: "channels",
        sortable: false,
        class: "text-center min-w-140px",
      },
      {
        name: "Tổng số",
        key: "emailTotal",
        sortable: false,
        class: "text-center",
      },
      {
        name: "Đã gửi",
        key: "sentEmailTotal",
        sortable: false,
        class: "text-center",
      },
      {
        name: "Thất bại",
        key: "failedEmailTotal",
        sortable: false,
        class: "text-center",
      },
      {
        name: "Đã đọc mail",
        key: "openedTotal",
        sortable: false,
        class: "text-center",
      },
      {
        //Cột này trước để TÊN RỖNG (chỉ có thanh tiến trình) — người dùng không biết cột gì
        name: "Trạng thái",
        key: "process",
        sortable: false,
        class: "text-center w-100px",
      },
      {
        name: "Hành động",
        key: "actions",
        sortable: false,
        class: "text-center",
      },
    ]);
    const arrTag = {
      all: {
        label: "Thí sinh đã trúng tuyển",
        state: "primary",
      },
      all_reg: {
        label: "Tất cả (có hồ sơ)",
        state: "danger",
      },
      all_noreg: {
        label: "Tất cả (chưa có hồ sơ)",
        state: "danger",
      },
      read: {
        label: "Trúng tuyển (đọc mail)",
        state: "info",
      },
      unread: {
        label: "Trúng tuyển (chưa đọc mail)",
        state: "warning",
      },
      custom: {
        label: "Import tập tin",
        state: "success",
      },
    };
    const formData = ref<IData>({
      name: "",
      phase: "",
      method: "HOCBA",
      graduationStatus: "graduated",
      typeTemplate: "",
      typeTime: "",
      time: "",
      id: "",
      peopleTarget: "",
      smsMessage: "",
      zaloTemplateId: "",
    });
    const tableData = ref<Array<ICustomer>>([]);
    const initCustomers = ref<Array<ICustomer>>([]);
    const statusTag = {
      new: {
        label: "Mới",
        state: "primary",
      },
      processing: {
        label: "Chưa hoàn tất",
        state: "warning",
      },
      verified: {
        label: "Đã xác thực",
        state: "success",
      },
      rejected: {
        label: "Không hợp lệ",
        state: "danger",
      },
    };
    onMounted(async () => {
      //getData()
      //initCustomers.value.splice(0, tableData.value.length, ...tableData.value);
      //console.log(tableData.value)
    });

    const deleteCustomer = async (id) => {
      for (let i = 0; i < tableData.value.length; i++) {
        if (tableData.value[i].id == id) {
          tableData.value.splice(i, 1);
        }
      }
      for (let i = 0; i < initCustomers.value.length; i++) {
        if (initCustomers.value[i].id == id) {
          initCustomers.value.splice(i, 1);
        }
      }
    };
    const search = ref<string>("");
    const searchItems = () => {
      tableData.value.splice(0, tableData.value.length, ...initCustomers.value);
      if (search.value !== "") {
        let results: Array<ICustomer> = [];
        for (let j = 0; j < tableData.value.length; j++) {
          if (searchingFunc(tableData.value[j], search.value)) {
            results.push(tableData.value[j]);
          }
        }
        tableData.value.splice(0, tableData.value.length, ...results);
      }
    };

    const searchingFunc = (obj, value): boolean => {
      obj = JSON.parse(JSON.stringify(obj));
      obj.status = statusTag[obj.status]?.label;
      obj.typeAdmission = arrTag[obj.typeAdmission]
        ? arrTag[obj.typeAdmission]?.label
        : obj.typeAdmission;
      for (let key in obj) {
        if (obj[key] && typeof obj[key] === "string") {
          if (obj[key].toUpperCase().indexOf(value.toUpperCase()) != -1) {
            return true;
          }
        }
      }
      return false;
    };
    const formRef = ref();
    function popupLoading() {
      Swal.fire({
        html: "<div class='custom-loading'><span>Đang xử lý. Vui lòng chờ trong giây lát!!!</span> <span class='loader'></span></div>",
        buttonsStyling: false,
        timerProgressBar: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
      }).then(() => {
        //
      });
    }
    const addExporResultModalRef = ref<null | HTMLElement>(null);
    const kt_modal_option_add = ref<null | HTMLElement>(null);
    const kt_modal_option_send = ref<null | HTMLElement>(null);
    const kt_modal_option_send_modal = ref<null | HTMLElement>(null);

    const isEdit = ref(false);
    const formRefOptionData = ref()
    const tempRecord = ref({} as any)
    const optionData = ref({
        type: ['email'],
        option: '1',
      } as any)
    const submit = () => {
      if (!formRef.value) {
        return;
      }
      //Không chọn kênh nào thì chiến dịch chẳng gửi đi đâu — trước đây vẫn lưu được, tạo ra bản ghi chết.
      if (!optionData.value.type || optionData.value.type.length === 0) {
        Swal.fire({
          text: "Chọn ít nhất một kênh gửi (Email, SMS hoặc Zalo) trước khi lưu.",
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "Đã hiểu",
          customClass: { confirmButton: "btn btn-primary" },
        });
        return;
      }
      formRef.value.validate(async (valid) => {
        if (valid) {
          let data = {
            name: formData.value.name,
            phaseTarget: formData.value.phase,
            methodTarget: formData.value.method,
            zaloChecked: optionData.value.type.includes('zalo'),
            zaloTemplateId: optionData.value.type.includes('zalo')?formData.value.zaloTemplateId:undefined,
            smsChecked: optionData.value.type.includes('sms'),
            smsMessage: optionData.value.type.includes('sms')?formData.value.smsMessage:undefined,
            mailChecked: optionData.value.type.includes('email'),
            mailTemplateId: optionData.value.type.includes('email')?formData.value.typeTemplate.toString():undefined,
            peopleTarget: formData.value.peopleTarget,
            campaignType: "MARKETING",
          };
          let methodApi = "post";
          let currentApi = "";
          if (isEdit.value) {
            methodApi = "put";
            currentApi = `${formData.value.id}`;
            data.mailChecked = data.mailChecked? '1':'0'
            data.smsChecked = data.smsChecked? '1':'0'
            data.zaloChecked = data.zaloChecked? '1':'0'
          }
          popupLoading()
          await axios[methodApi](`/campaign/marketing/${currentApi}`, data)
            .then(({ data }) => {
              data.campaign.createdAtFormat = moment(data.campaign.createdAt).format("DD/MM/YYYY HH:mm");
              data.campaign.createdAt = data.campaign.createdAt?Number(new Date(data.campaign.createdAt)):'',
              data.campaign.failedEmailTotal = 0
              data.campaign.failedSmsTotal = 0
              data.campaign.failedZaloTotal = 0
              data.campaign.percent = 0; //(data.item.sentEmailTotal*100/data.item.emailTotal).toFixed(0)
              data.campaign.groupTarget = `${
                data.campaign.methodTarget == "HOCBA"
                  ? "Học bạ"
                  : data.campaign.methodTarget == "UMT"
                  ? "UMT"
                  : data.campaign.methodTarget == "DGNL"
                  ? "Đánh giá năng lực ĐHQG"
                  : data.campaign.methodTarget == "THPT"
                  ? "Tổng nghiệp THPT"
                  : data.campaign.methodTarget == 'all'
                  ? "Tất cả"
                  : data.campaign.methodTarget
                  ? data.campaign.methodTarget
                : ''
              }`;
              if (isEdit.value) {
                data.campaign.percent = 0;
                let index = tableData.value.findIndex(
                  (item) => item.id == formData.value.id
                );
                tableData.value[index] = data.campaign;
              } else {
                tableData.value.unshift(data.campaign);
              }
              hideModal(addExporResultModalRef.value);
              reinitializeComponents();
              Swal.close()
            })
            .catch(({ response }) => {
              //response.data.message có thể KHÔNG tồn tại (BE trả errorMessage) -> .split() ném
              //TypeError ngay trong catch, người dùng không thấy thông báo nào cả.
              const raw = String(response?.data?.errorMessage || response?.data?.message || '')
              let errorMessage = raw.split('|').pop() || 'Có lỗi trong quá trình thực hiện'
              if (raw.includes('APP-100-400')) {
                errorMessage = 'Không tìm thấy thí sinh nào khớp bộ lọc ở mục 1. Chọn lại nhóm/đợt/phương thức rồi thử lại.'
              }
              Swal.fire({
                text: errorMessage,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Đóng",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              }).then(() => {
                Swal.close();
              }, 300);
              // console.log("err", response);
            });
        } else {
          return false;
        }
      });
    };

    return {
      tableData,
      initCustomers,
      tableHeader,
      deleteCustomer,
      search,
      searchItems,
      checkedCustomers,
      pagination,
      statusTag,
      Permission,
      arrMajors,
      formData,
      formRef,
      submit,
      rules,
      optionRules,
      arrTag,
      addExporResultModalRef,
      kt_modal_option_add,
      popupLoading,
      filterList,
      isEdit,
      arrZaloTemplateids,
      optionData,
      kt_modal_option_send,
      kt_modal_option_send_modal,
      formRefOptionData,
      tempRecord,
      reviewZalo,
      viewTemplateMail,
    };
  },
});
